<template>
  <div class="limiter">
    <!-- Navbar -->
    <nav class="custom-navbar">
      <div class="container-fluid d-flex justify-content-between align-items-center">
        <a class="navbar-brand" href="#">
          <img src="../assets/images/logo.png" alt="Logo" height="40" />
        </a>

        <div class="d-flex">
          <button @click="() => this.$router.push({ name: 'form' })" class="btn btn-outline-primary me-2">
            <i class="fas fa-user-plus me-1"></i>Cadastrar
          </button>
          <button @click="abrirLoginModal" class="btn btn-success">
            <i class="fas fa-sign-in-alt me-1"></i>Área do Candidato
          </button>
        </div>
      </div>
    </nav>

    <!-- Hero Section com Estatísticas -->
    <div class="hero-section">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center mb-4">
            <h1 class="hero-title">Portal de Concursos Públicos</h1>
            <p class="hero-subtitle">Encontre as melhores oportunidades</p>
          </div>
    </div>

      </div>
    </div>

    <!-- Filtros e Busca -->
    <div class="filters-section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="filters-card">
              <div class="row align-items-end">
                <div class="col-md-3 mb-3">
                  <label class="form-label">Buscar</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="fas fa-search"></i></span>
                    <input 
                      v-model="filtros.busca" 
                      type="text" 
                      class="form-control" 
                      placeholder="Digite o título do concurso..."
                      @input="debounceBusca"
                    />
                  </div>
                </div>
                <div class="col-md-2 mb-3">
                  <label class="form-label">Status</label>
                  <select v-model="filtros.status" class="form-select" @change="aplicarFiltros">
                    <option value="todos">Todos</option>
                    <option value="ABERTAS">Abertas</option>
                    <option value="ENCERRADAS">Encerradas</option>
                    <option value="AGUARDANDO">Aguardando</option>
                  </select>
                </div>
                <div class="col-md-2 mb-3">
                  <label class="form-label">Prefeitura</label>
                  <select v-model="filtros.prefeitura" class="form-select" @change="aplicarFiltros">
                    <option value="">Todas</option>
                    <option v-for="prefeitura in prefeituras" :key="prefeitura" :value="prefeitura">
                      {{ prefeitura }}
                    </option>
                  </select>
                </div>
                <div class="col-md-2 mb-3">
                  <label class="form-label">Tipo</label>
                  <select v-model="filtros.tipo" class="form-select" @change="aplicarFiltros">
                    <option value="">Todos</option>
                    <option v-for="tipo in tipos" :key="tipo" :value="tipo">
                      {{ tipo }}
                    </option>
                  </select>
                </div>
                <div class="col-md-2 mb-3">
                  <label class="form-label">Ordenar</label>
                  <select v-model="filtros.ordenacao" class="form-select" @change="aplicarFiltros">
                    <option value="data_prazo_fim">Data de Encerramento</option>
                    <option value="titulo">Título</option>
                    <option value="id">Mais Recentes</option>
                  </select>
                </div>
                <div class="col-md-1 mb-3">
                  <button @click="limparFiltros" class="btn btn-outline-secondary w-100" title="Limpar Filtros">
                    <i class="fas fa-times"></i>
                  </button>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
      <div class="text-center">
        <img src="@/assets/images/loading.gif" class="img-fluid mb-3" style="max-width: 100px; max-height: 100px;" />
        <p class="text-muted">Carregando concursos...</p>
      </div>
    </div>

    <!-- Listagem de Concursos -->
    <div v-if="!isLoading" class="concursos-section">
      <div class="container">
        <div class="row">
          <div class="col-12 mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="section-title">
                <i class="fas fa-list me-2"></i>Concursos Disponíveis
                <span class="badge bg-primary ms-2">{{ concursos.length }}</span>
              </h4>
              <div class="view-toggle">
                <button 
                  @click="visualizacao = 'cards'" 
                  :class="['btn btn-sm', visualizacao === 'cards' ? 'btn-primary' : 'btn-outline-primary']"
                >
                  <i class="fas fa-th-large"></i>
                </button>
                <button 
                  @click="visualizacao = 'lista'" 
                  :class="['btn btn-sm ms-1', visualizacao === 'lista' ? 'btn-primary' : 'btn-outline-primary']"
                >
                  <i class="fas fa-list"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Visualização em Cards -->
        <div v-if="visualizacao === 'cards'" class="row">
          <div v-for="concurso in concursos" :key="concurso.id" class="col-lg-6 col-xl-4 mb-4">
            <div class="concurso-card-modern">
              <div class="card-header-modern">
                <div class="prefeitura-badge" :style="{ backgroundColor: getPrefeituraColor(concurso.prefeitura) }">
                  {{ concurso.prefeitura }}
                </div>
                <div class="status-badge" :class="getStatusClass(concurso.status_inscricoes)">
                  {{ concurso.status_inscricoes }}
                </div>
              </div>
              
              <div class="card-body-modern">
                <h5 class="concurso-titulo">{{ concurso.titulo }}</h5>
                <p class="concurso-descricao">{{ truncateText(concurso.descricao, 100) }}</p>
                
                <div class="concurso-info">
                  <div class="info-item">
                    <i class="fas fa-calendar-alt"></i>
                    <span>Período de Inscrição: {{ formatarData(concurso.data_prazo_inicio) }} à {{ formatarData(concurso.data_prazo_fim) }}</span>
                  </div>
                  <div class="info-item">
                    <i class="fas fa-briefcase"></i>
                    <span>{{ concurso.total_vagas }} cargos</span>
                  </div>
                  <div class="info-item">
                    <i class="fas fa-tag"></i>
                    <span>{{ concurso.tipo }}</span>
                  </div>
                </div>

                <!-- Dias até o início (quando ainda não começou) -->
                <div v-if="concurso.status_inscricoes === 'AGUARDANDO' && concurso.dias_ate_inicio !== null && concurso.dias_ate_inicio >= 0" class="dias-restantes dias-ate-inicio">
                  <i class="fas fa-hourglass-start"></i>
                  <span v-if="concurso.dias_ate_inicio === 0 && concurso.horas_ate_inicio !== null">
                    <span v-if="concurso.horas_ate_inicio === 0">Inscrições começam em breve!</span>
                    <span v-else-if="concurso.horas_ate_inicio === 1">Inscrições começam em 1 hora!</span>
                    <span v-else>Inscrições começam em {{ concurso.horas_ate_inicio }} horas!</span>
                  </span>
                  <span v-else-if="concurso.dias_ate_inicio === 1">Inscrições começam amanhã!</span>
                  <span v-else>{{ concurso.dias_ate_inicio }} dias até o início das inscrições</span>
                </div>

                <!-- Dias até o encerramento (quando já está aberto) -->
                <div v-if="concurso.status_inscricoes === 'ABERTAS' && concurso.dias_ate_encerramento !== null && concurso.dias_ate_encerramento > 0" class="dias-restantes dias-ate-encerramento">
                  <i class="fas fa-clock"></i>
                  <span v-if="concurso.dias_ate_encerramento === 1">Último dia para inscrição!</span>
                  <span v-else>{{ concurso.dias_ate_encerramento }} dias restantes para inscrição</span>
                </div>
              </div>

              <div class="card-footer-modern">
                <button @click="abrirModalPublicacoes(concurso.id)" class="btn btn-outline-primary btn-sm">
                  <i class="fas fa-file-alt me-1"></i>Publicações
                </button>
                <button @click="abrirModalVagas(concurso.id)" class="btn btn-outline-success btn-sm">
                  <i class="fas fa-users me-1"></i>Cargos
                </button>
                <button @click="abrirLoginModal" class="btn btn-success btn-sm">
                  <i class="fas fa-user-plus me-1"></i>Inscrever-se
                </button>
                <button v-if="concurso.link_area_candidato" @click="abrirLinkExterno(concurso.link_area_candidato)" class="btn btn-primary btn-sm">
                  <i class="fas fa-external-link-alt me-1"></i>Cadastrar-se
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Visualização em Lista -->
        <div v-else class="row">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-hover">
          <thead>
            <tr>
                    <th>Concurso</th>
                    <th>Prefeitura</th>
                    <th>Status</th>
                    <th>Período</th>
                    <th>Vagas</th>
                    <th>Ações</th>
            </tr>
          </thead>
          <tbody>
                  <tr v-for="concurso in concursos" :key="concurso.id">
                    <td>
                      <div>
                        <strong>{{ concurso.titulo }}</strong>
                        <br>
                        <small class="text-muted">{{ concurso.tipo }}</small>
                      </div>
                    </td>
                    <td>
                      <span class="prefeitura-badge-small" :style="{ backgroundColor: getPrefeituraColor(concurso.prefeitura) }">
                        {{ concurso.prefeitura }}
                      </span>
                    </td>
                    <td>
                      <span class="badge" :class="getStatusClass(concurso.status_inscricoes)">
                        {{ concurso.status_inscricoes }}
                      </span>
                    </td>
                    <td>
                      <div>
                        <small>{{ formatarData(concurso.data_prazo_inicio) }} à {{ formatarData(concurso.data_prazo_fim) }} </small>
                      </div>
                    </td>
                    <td>
                      <span class="badge bg-info">{{ concurso.total_vagas }}</span>
                    </td>
                    <td>
                      <div class="btn-group btn-group-sm">
                        <button @click="abrirModalPublicacoes(concurso.id)" class="btn btn-outline-primary" title="Publicações">
                          <i class="fas fa-file-alt"></i>
                        </button>
                        <button @click="abrirModalVagas(concurso.id)" class="btn btn-outline-success" title="Vagas">
                          <i class="fas fa-users"></i>
                        </button>
                        <button @click="abrirLoginModal" class="btn btn-success" title="Inscrever-se">
                          <i class="fas fa-user-plus"></i>
                        </button>
                        <button v-if="concurso.link_area_candidato" @click="abrirLinkExterno(concurso.link_area_candidato)" class="btn btn-primary" title="Cadastrar-se">
                          <i class="fas fa-external-link-alt"></i>
                        </button>
                      </div>
              </td>
            </tr>
          </tbody>
        </table>
            </div>
          </div>
        </div>

        <!-- Mensagem quando não há concursos -->
        <div v-if="concursos.length === 0 && !isLoading" class="row">
          <div class="col-12 text-center py-5">
            <i class="fas fa-search fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">Nenhum concurso encontrado</h5>
            <p class="text-muted">Tente ajustar os filtros de busca</p>
            <div class="d-flex justify-content-center gap-2">
              <button @click="limparFiltros" class="btn btn-primary">
                <i class="fas fa-refresh me-1"></i>Limpar Filtros
              </button>
              <button @click="carregarConcursos" class="btn btn-outline-primary">
                <i class="fas fa-redo me-1"></i>Recarregar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Publicações -->
    <div v-if="showModalPublicacoes" class="modal-overlay" @click="fecharModalPublicacoes">
      <div class="modal-content" ref="modalPublicacoes" @click.stop>
        <div class="modal-header">
          <div class="modal-icon">
            <i class="fas fa-file-alt"></i>
          </div>
          <h4 class="modal-title">Publicações Oficiais</h4>
          <p class="modal-subtitle">Documentos e editais relacionados ao concurso</p>
          <button @click="fecharModalPublicacoes" class="modal-close-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div v-if="modalPublicacoes.length === 0" class="empty-state">
            <i class="fas fa-file-alt fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">Nenhuma publicação disponível</h5>
            <p class="text-muted">As publicações serão disponibilizadas conforme o cronograma do concurso.</p>
          </div>

          <div v-else class="publications-list">
            <div v-for="item in modalPublicacoes" :key="item.id" class="publication-item">
              <div class="publication-info">
                <div class="publication-date">
                  <i class="fas fa-calendar-alt me-2"></i>
                  {{ formatarData(item.data_publicacao) }}
                </div>
                <h6 class="publication-title">{{ item.titulo }}</h6>
                <p v-if="item.descricao" class="publication-description">{{ item.descricao }}</p>
              </div>
              <div class="publication-actions">
                <a 
                  v-if="item.caminho_arquivo" 
                  :href="item.caminho_arquivo" 
                  target="_blank" 
                  class="btn btn-primary btn-sm"
                >
                  <i class="fas fa-download me-1"></i>Baixar
                </a>
                <span v-else class="text-muted small">Arquivo não disponível</span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="fecharModalPublicacoes" class="btn btn-secondary">
            <i class="fas fa-times me-1"></i>Fechar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Vagas -->
    <div v-if="showModalVagas" class="modal-overlay" @click="fecharModalVagas">
      <div class="modal-content" ref="modalVagas" @click.stop>
        <div class="modal-header">
          <div class="modal-icon">
            <i class="fas fa-briefcase"></i>
          </div>
          <h4 class="modal-title">Cargos Disponíveis</h4>
          <p class="modal-subtitle"></p>
          <button @click="fecharModalVagas" class="modal-close-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div v-if="modalVagas.length === 0" class="empty-state">
            <i class="fas fa-briefcase fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">Nenhuma vaga disponível</h5>
            <p class="text-muted">As vagas serão disponibilizadas conforme o cronograma do concurso.</p>
          </div>

          <div v-else class="vagas-list">
            <div v-for="vaga in modalVagas" :key="vaga.id" class="vaga-item">
              <div class="vaga-header">
                <h6 class="vaga-cargo">{{ vaga.cargo }}</h6>
                <span 
                  class="vaga-nivel badge" 
                  :class="getNivelClass(vaga.nivel)"
                  :style="{ backgroundColor: getNivelColor(vaga.nivel) }"
                >
                  {{ vaga.nivel }}
                </span>
              </div>
              
              <div class="vaga-details">
                <div class="vaga-info">
                  <div v-if="vaga.valor_remuneracao" class="info-row">
                    <i class="fas fa-money-bill-wave me-2"></i>
                    <span class="info-label">Remuneração:</span>
                    <span class="info-value price">R$ {{ formatarValor(vaga.valor_remuneracao) }}</span>
                  </div>
                  <div v-else class="info-row">
                    <i class="fas fa-money-bill-wave me-2"></i>
                    <span class="info-label">Remuneração:</span>
                    <span class="info-value">Não informado</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="fecharModalVagas" class="btn btn-secondary">
            <i class="fas fa-times me-1"></i>Fechar
          </button>
        </div>
      </div>
    </div>


    <!-- Modal de Login -->
    <Login v-if="showLoginModal" @close-modal="fecharLoginModal" />

    <!-- Modal de Aviso -->
    <div v-if="showAvisoModal && temInscricoesAbertas" class="aviso-modal-overlay" @click="fecharAviso">
      <div class="aviso-modal-content" @click.stop>
        <div class="aviso-header">
          <div class="aviso-icon">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <h5 class="aviso-title">Atenção</h5>
          <button @click="fecharAviso" class="aviso-close-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="aviso-body">
          <p class="aviso-text">
            Antes de realizar a inscrição, o candidato deve possuir cadastro na plataforma. Caso ainda não tenha, deverá efetuá-lo por meio do botão azul localizado no canto direito da tela.
          </p>
          <p class="aviso-text">
            Após concluir o cadastro, acesse a Área do Candidato e proceda com a inscrição no processo seletivo.
          </p>
        </div>
        <div class="aviso-footer">
          <button @click="fecharAviso" class="btn btn-primary btn-aviso-ok">
            <i class="fas fa-check me-2"></i>
            Entendi
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Login from "@/components/Login";

export default {
  name: "HomeView",
  components: { Login },

  data() {
    return {
      showLoginModal: false,
      showAvisoModal: false,
      showModalPublicacoes: false,
      showModalVagas: false,
      isLoading: false,
      modalPublicacoes: [],
      modalVagas: [],
      concursos: [],
      prefeituraColors: {},
      estatisticas: null,
      prefeituras: [],
      tipos: [],
      visualizacao: 'cards',
      filtros: {
        busca: '',
        status: 'todos',
        prefeitura: '',
        tipo: '',
        ordenacao: 'data_prazo_fim',
        direcao: 'desc'
      },
      buscaTimeout: null
    };
  },

  created() {
    this.carregarDadosIniciais();
  },

  computed: {
    temInscricoesAbertas() {
      return this.concursos.some(concurso => concurso.status_inscricoes === 'ABERTAS');
    }
  },

  methods: {
    async carregarDadosIniciais() {
      try {
        this.isLoading = true;
        
        // Carregar dados em paralelo
        const [concursosResponse, estatisticasResponse, prefeiturasResponse, tiposResponse] = await Promise.allSettled([
          axios.get("/ps/concurso", { params: this.filtros }),
          axios.get("/ps/concurso/estatisticas"),
          axios.get("/ps/concurso/prefeituras"),
          axios.get("/ps/concurso/tipos")
        ]);

        // Processar resultados
        if (concursosResponse.status === 'fulfilled') {
          this.concursos = concursosResponse.value.data;
          // Carregar vagas e calcular totais para cada concurso
          await this.carregarVagasEcalcularTotais();
        } else {
          console.error("Erro ao carregar concursos:", concursosResponse.reason);
          this.concursos = [];
          this.$sweet.showError("Erro ao carregar concursos. Tente novamente.");
        }

        if (estatisticasResponse.status === 'fulfilled') {
          this.estatisticas = estatisticasResponse.value.data;
        } else {
          console.error("Erro ao carregar estatísticas:", estatisticasResponse.reason);
          this.estatisticas = null;
        }

        if (prefeiturasResponse.status === 'fulfilled') {
          this.prefeituras = prefeiturasResponse.value.data;
        } else {
          console.error("Erro ao carregar prefeituras:", prefeiturasResponse.reason);
          this.prefeituras = [];
        }

        if (tiposResponse.status === 'fulfilled') {
          this.tipos = tiposResponse.value.data;
        } else {
          console.error("Erro ao carregar tipos:", tiposResponse.reason);
          this.tipos = [];
        }
        
        this.isLoading = false;
      } catch (error) {
        console.error("Erro geral ao carregar dados:", error);
        this.isLoading = false;
        this.$sweet.showError("Erro ao carregar dados. Verifique sua conexão e tente novamente.");
      }
    },

    async carregarConcursos() {
      try {
        this.isLoading = true;
        const { data } = await axios.get("/ps/concurso", { params: this.filtros });
        this.concursos = data;
        // Carregar vagas e calcular totais para cada concurso
        await this.carregarVagasEcalcularTotais();
        this.isLoading = false;
      } catch (error) {
        console.error("Erro ao carregar concursos:", error);
        this.concursos = [];
        this.isLoading = false;
        
        // Tratamento específico de erros
        if (error.response) {
          const status = error.response.status;
          if (status === 404) {
            this.$sweet.showWarning("Nenhum concurso encontrado com os filtros aplicados.");
          } else if (status >= 500) {
            this.$sweet.showError("Erro interno do servidor. Tente novamente mais tarde.");
          } else {
            this.$sweet.showError("Erro ao carregar concursos. Tente novamente.");
          }
        } else if (error.request) {
          this.$sweet.showError("Erro de conexão. Verifique sua internet e tente novamente.");
        } else {
          this.$sweet.showError("Erro inesperado. Tente novamente.");
        }
      }
    },

    aplicarFiltros() {
      this.carregarConcursos();
    },

    debounceBusca() {
      clearTimeout(this.buscaTimeout);
      this.buscaTimeout = setTimeout(() => {
        this.aplicarFiltros();
      }, 500);
    },

    limparFiltros() {
      this.filtros = {
        busca: '',
        status: 'todos',
        prefeitura: '',
        tipo: '',
        ordenacao: 'data_prazo_fim',
        direcao: 'desc'
      };
      this.carregarConcursos();
    },

    abrirLinkExterno(url) {
      window.open(url, '_blank');
    },

    truncateText(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    },

    getStatusClass(status) {
      const classes = {
        'ABERTAS': 'bg-success',
        'ENCERRADAS': 'bg-danger',
        'AGUARDANDO': 'bg-warning'
      };
      return classes[status] || 'bg-secondary';
    },

    formatarData(data) {
      if (!data) return "-";
      
      try {
        // Se a data vem no formato YYYY-MM-DD (sem horário), extrair diretamente
        if (typeof data === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
          const [year, month, day] = data.split('-')
          return `${day}/${month}/${year}`
        }
        
        // Tratar formato do banco: YYYY-MM-DD HH:mm:ss (com espaço)
        if (typeof data === 'string') {
          let dateString = data.replace('Z', '')
          
          // Se tiver formato com espaço (formato do banco: YYYY-MM-DD HH:mm:ss)
          if (dateString.match(/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}/)) {
            const [datePart, timePart] = dateString.split(' ')
            const [year, month, day] = datePart.split('-')
            const [hours, minutes] = timePart.split(':')
            return `${day}/${month}/${year} ${hours}:${minutes}`
          }
          
          // Para datas ISO com timezone
          if (dateString.includes('T')) {
            const [datePart, timePart] = dateString.split('T')
            const [year, month, day] = datePart.split('-')
            const timeClean = timePart.replace(/[Z+-].*$/, '')
            const [hours, minutes] = timeClean.split(':')
            return `${day}/${month}/${year} ${hours}:${minutes}`
          }
        }
        
        // Fallback: usar new Date() se necessário
        const date = new Date(data)
        if (isNaN(date.getTime())) return "-"
        
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        
        return `${day}/${month}/${year} ${hours}:${minutes}`
      } catch (error) {
        return "-"
      }
    },

    formatarDataPagamento(data) {
      if (!data) return "-";
      
      // Se a data vem no formato YYYY-MM-DD (sem horário), extrair diretamente
      if (typeof data === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
        const [year, month, day] = data.split('-')
        return `${day}/${month}/${year}`
      }
      
      // Usar horário local (sem conversão UTC)
      const date = new Date(data)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      
      return `${day}/${month}/${year}`
    },

    async abrirModalPublicacoes(concursoId) {
      try {
        const { data } = await axios.get(`/ps/concurso/${concursoId}/publicacoes`);
        this.modalPublicacoes = data;
        this.showModalPublicacoes = true;
      } catch (error) {
        console.error("Erro ao carregar publicações:", error);
        this.modalPublicacoes = [];
        this.$sweet.showError("Erro ao carregar publicações");
      }
    },

    async abrirModalVagas(concursoId) {
      try {
        const { data } = await axios.get(`/ps/concurso/${concursoId}/vagas`);
        // Ordenar vagas por nível e valor de remuneração (decrescente)
        this.modalVagas = this.ordenarVagas(data);
        this.showModalVagas = true;
      } catch (error) {
        console.error("Erro ao carregar vagas:", error);
        this.modalVagas = [];
        this.$sweet.showError("Erro ao carregar vagas");
      }
    },

    ordenarVagas(vagas) {
      if (!vagas || vagas.length === 0) return vagas;

      // Ordem de prioridade dos níveis (decrescente)
      const ordemNiveis = {
        'Pós-graduação': 4,
        'Superior/Professor': 3,
        'Superior': 2,
        'Técnico': 1
      };

      return [...vagas].sort((a, b) => {
        // Primeiro, ordenar por nível (decrescente)
        const nivelA = ordemNiveis[a.nivel] || 0;
        const nivelB = ordemNiveis[b.nivel] || 0;
        
        if (nivelA !== nivelB) {
          return nivelB - nivelA; // Decrescente
        }

        // Se o nível for igual, ordenar por valor de remuneração (decrescente)
        const valorA = parseFloat(a.valor_remuneracao) || 0;
        const valorB = parseFloat(b.valor_remuneracao) || 0;
        
        return valorB - valorA; // Decrescente
      });
    },

    getPrefeituraColor(prefeitura) {
      if (!this.prefeituraColors[prefeitura]) {
        this.prefeituraColors[prefeitura] = this.generateColor(prefeitura);
      }
      return this.prefeituraColors[prefeitura];
    },

    generateColor(text) {
      let hash = 0;
      for (let i = 0; i < text.length; i++) {
        hash = text.charCodeAt(i) + ((hash << 5) - hash);
      }
      let color = "#";
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xff;
        color += ("00" + value.toString(16)).substr(-2);
      }
      return color;
    },

    abrirLoginModal() {
      this.showLoginModal = true;
    },

    fecharLoginModal() {
      this.showLoginModal = false;
    },

    fecharAviso() {
      this.showAvisoModal = false;
    },

    fecharModalPublicacoes() {
      this.showModalPublicacoes = false;
    },

    fecharModalVagas() {
      this.showModalVagas = false;
    },





    formatarValor(valor) {
      if (!valor) return '0,00';
      const valorNumerico = parseFloat(valor);
      if (isNaN(valorNumerico)) return '0,00';
      
      // Formatar com separador de milhares e decimais
      return valorNumerico.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    getNivelColor(nivel) {
      const cores = {
        'Técnico': '#17a2b8', // Azul claro
        'Superior': '#28a745', // Verde
        'Superior/Professor': '#ffc107', // Amarelo
        'Pós-graduação': '#6f42c1' // Roxo
      };
      return cores[nivel] || '#6c757d'; // Cinza padrão
    },

    getNivelClass(nivel) {
      const classes = {
        'Técnico': 'bg-info',
        'Superior': 'bg-success',
        'Superior/Professor': 'bg-warning',
        'Pós-graduação': 'bg-purple'
      };
      return classes[nivel] || 'bg-secondary';
    },

    async carregarVagasEcalcularTotais() {
      // Carregar vagas para cada concurso e calcular totais
      const promises = this.concursos.map(async (concurso) => {
        try {
          // Buscar vagas do concurso
          const { data: vagas } = await axios.get(`/ps/concurso/${concurso.id}/vagas`);
          
          // Debug: verificar estrutura das vagas
          if (vagas && vagas.length > 0) {
            // console.log('Vagas do concurso', concurso.id, ':', vagas[0]);
          }
          
          // Calcular total de vagas
          if (!vagas || vagas.length === 0) {
            concurso.total_vagas = 0;
          } else {
            // Verificar múltiplos possíveis nomes de campos
            let totalCalculado = 0;
            let temCampoQuantidade = false;
            
            vagas.forEach(vaga => {
              // Tentar encontrar o campo de quantidade
              const quantidade = vaga.quantidade || 
                                vaga.quantidade_vagas || 
                                vaga.quantidade_vaga;
              
              if (quantidade !== undefined && quantidade !== null) {
                const qtd = parseInt(quantidade);
                if (!isNaN(qtd) && qtd > 0) {
                  totalCalculado += qtd;
                  temCampoQuantidade = true;
                }
              }
            });
            
            // Se não encontrou campo de quantidade, contar número de vagas cadastradas
            if (!temCampoQuantidade || totalCalculado === 0) {
              concurso.total_vagas = vagas.length;
            } else {
              concurso.total_vagas = totalCalculado;
            }
          }

          // Usar new Date diretamente - interpreta a data da API no horário local
          const hoje = new Date();
          const inicio = concurso.data_prazo_inicio ? new Date(concurso.data_prazo_inicio) : null;
          const fim = concurso.data_prazo_fim ? new Date(concurso.data_prazo_fim) : null;
          
          // Calcular status das inscrições usando horário local
          if (inicio && fim) {
            if (hoje < inicio) {
              concurso.status_inscricoes = 'AGUARDANDO';
            } else if (hoje >= inicio && hoje <= fim) {
              concurso.status_inscricoes = 'ABERTAS';
            } else {
              concurso.status_inscricoes = 'ENCERRADAS';
            }
          }

          // Calcular dias até o início (quando ainda não começou)
          if (concurso.data_prazo_inicio && inicio) {
            const diffTimeInicio = inicio.getTime() - hoje.getTime();
            const diffMsInicio = diffTimeInicio;
            const diffHoursInicio = Math.floor(diffMsInicio / (1000 * 60 * 60));
            const diffDaysInicio = Math.floor(diffMsInicio / (1000 * 60 * 60 * 24));
            
            // Verificar se é o mesmo dia usando horário local
            const hojeDate = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
            const inicioDate = new Date(inicio.getFullYear(), inicio.getMonth(), inicio.getDate());
            const mesmoDia = hojeDate.getTime() === inicioDate.getTime();
            
            if (mesmoDia && diffHoursInicio >= 0) {
              // Mesmo dia - mostrar horas
              concurso.dias_ate_inicio = 0;
              concurso.horas_ate_inicio = diffHoursInicio;
            } else if (diffDaysInicio === 0 && diffHoursInicio < 0) {
              // Já passou mas ainda não começou
              concurso.dias_ate_inicio = 0;
              concurso.horas_ate_inicio = 0;
            } else {
              // Próximo dia ou mais
              concurso.dias_ate_inicio = diffDaysInicio > 0 ? diffDaysInicio : 0;
              concurso.horas_ate_inicio = null;
            }
          } else {
            concurso.dias_ate_inicio = null;
            concurso.horas_ate_inicio = null;
          }

          // Calcular dias até o encerramento (quando já está aberto)
          if (concurso.data_prazo_fim && fim) {
            const diffTimeFim = fim.getTime() - hoje.getTime();
            const diffDaysFim = Math.ceil(diffTimeFim / (1000 * 60 * 60 * 24));
            concurso.dias_ate_encerramento = diffDaysFim > 0 ? diffDaysFim : 0;
          } else {
            concurso.dias_ate_encerramento = null;
          }

          // Manter compatibilidade com código antigo
          concurso.dias_restantes = concurso.dias_ate_encerramento;

          // Adicionar descricao se não existir
          if (!concurso.descricao) {
            concurso.descricao = '';
          }

          return concurso;
        } catch (error) {
          console.error(`Erro ao carregar vagas do concurso ${concurso.id}:`, error);
          // Valores padrão em caso de erro
          concurso.total_vagas = 0;
          concurso.status_inscricoes = 'AGUARDANDO';
          concurso.dias_restantes = null;
          concurso.descricao = concurso.descricao || '';
          return concurso;
        }
      });

      await Promise.all(promises);
      
      // Abrir modal de aviso se houver inscrições abertas
      const temInscricoesAbertas = this.concursos.some(concurso => concurso.status_inscricoes === 'ABERTAS');
      if (temInscricoesAbertas) {
        this.showAvisoModal = true;
      }
    }
  }
};
</script>

<style lang="sass">
/* Imagem de fundo */
.limiter
  background-size: cover
  background-image: url('../assets/images/fundo-monocromatico.avif')
  background-position: center
  min-height: 100vh

/* Navbar */
.custom-navbar
  background-color: rgba(255, 255, 255, 0.95)
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1)
  padding: 15px 20px
  backdrop-filter: blur(10px)

/* Hero Section */
.hero-section
  padding: 40px 0
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(240, 248, 255, 0.9) 100%)
  margin-bottom: 5x

.hero-title
  font-size: 2.5rem
  font-weight: 700
  color: #2c3e50
  margin-bottom: 10px

.hero-subtitle
  font-size: 1.2rem
  color: #6c757d
  margin-bottom: 0

/* Cards de Estatísticas */
.stat-card
  background: white
  border-radius: 15px
  padding: 25px 15px
  text-align: center
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08)
  transition: transform 0.3s ease, box-shadow 0.3s ease
  border: 1px solid rgba(0, 0, 0, 0.05)

.stat-card:hover
  transform: translateY(-5px)
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15)

.stat-icon
  font-size: 2rem
  color: #007bff
  margin-bottom: 15px

.stat-number
  font-size: 2rem
  font-weight: 700
  color: #2c3e50
  margin-bottom: 5px

.stat-label
  font-size: 0.9rem
  color: #6c757d
  font-weight: 500

/* Filtros */
.filters-section
  margin-bottom: 30px

.filters-card
  background: white
  border-radius: 15px
  padding: 25px
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08)
  border: 1px solid rgba(0, 0, 0, 0.05)

.form-label
  font-weight: 600
  color: #495057
  margin-bottom: 8px

.input-group-text
  background-color: #f8f9fa
  border-color: #dee2e6

/* Seção de Concursos */
.concursos-section
  padding-bottom: 50px

.section-title
  color: #2c3e50
  font-weight: 600
  margin-bottom: 0

.view-toggle
  display: flex

/* Cards Modernos */
.concurso-card-modern
  background: white
  border-radius: 15px
  overflow: hidden
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08)
  transition: transform 0.3s ease, box-shadow 0.3s ease
  border: 1px solid rgba(0, 0, 0, 0.05)
  height: 100%

.concurso-card-modern:hover
  transform: translateY(-5px)
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15)

.card-header-modern
  padding: 15px 20px
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  display: flex
  justify-content: space-between
  align-items: center

.prefeitura-badge
  color: white
  font-weight: 600
  font-size: 0.8rem
  padding: 5px 12px
  border-radius: 20px
  text-transform: uppercase
  letter-spacing: 0.5px

.status-badge
  color: white
  font-weight: 600
  font-size: 0.75rem
  padding: 4px 10px
  border-radius: 15px
  text-transform: uppercase

.card-body-modern
  padding: 20px

.concurso-titulo
  font-size: 1.1rem
  font-weight: 600
  color: #2c3e50
  margin-bottom: 10px
  line-height: 1.4

.concurso-descricao
  color: #6c757d
  font-size: 0.9rem
  margin-bottom: 15px
  line-height: 1.5

.concurso-info
  margin-bottom: 15px

.info-item
  display: flex
  align-items: center
  margin-bottom: 8px
  font-size: 0.85rem
  color: #495057

.info-item i
  width: 16px
  margin-right: 8px
  color: #007bff

.dias-restantes
  color: white
  padding: 8px 12px
  border-radius: 20px
  font-size: 0.8rem
  font-weight: 600
  text-align: center
  margin-bottom: 15px
  display: flex
  align-items: center
  justify-content: center
  gap: 8px

.dias-ate-inicio
  background: linear-gradient(135deg, #3498db, #2980b9)
  color: white

.dias-ate-encerramento
  background: linear-gradient(135deg, #ff6b6b, #ee5a24)
  color: white

.card-footer-modern
  padding: 15px 20px
  background-color: #f8f9fa
  display: flex
  gap: 8px
  flex-wrap: wrap

/* Badges para tabela */
.prefeitura-badge-small
  color: white
  font-weight: 600
  font-size: 0.7rem
  padding: 3px 8px
  border-radius: 12px
  text-transform: uppercase

/* Modal */
.modal-overlay
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background: rgba(0, 0, 0, 0.6)
  display: flex
  justify-content: center
  align-items: flex-start
  z-index: 1050
  backdrop-filter: blur(5px)
  animation: fadeIn 0.3s ease-out
  padding: 20px
  padding-top: 50px
  box-sizing: border-box
  overflow-y: auto

@keyframes fadeIn
  from
    opacity: 0
  to
    opacity: 1

.modal-content
  background: white
  border-radius: 20px
  width: 100%
  max-width: 900px
  max-height: 90vh
  overflow: hidden
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25)
  display: flex
  flex-direction: column
  position: relative
  z-index: 1051
  opacity: 1
  transition: all 0.3s ease-out

@keyframes slideInUp
  from
    opacity: 0
    transform: translateY(-30px)
  to
    opacity: 1
    transform: translateY(0)

.modal-header
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  color: white
  padding: 25px 30px
  text-align: center
  position: relative

.modal-icon
  font-size: 2.5rem
  margin-bottom: 10px
  opacity: 0.9

.modal-title
  font-size: 1.4rem
  font-weight: 600
  margin-bottom: 5px

.modal-subtitle
  font-size: 0.9rem
  opacity: 0.9
  margin-bottom: 0

.modal-close-btn
  position: absolute
  top: 15px
  right: 15px
  background: rgba(255, 255, 255, 0.2)
  border: none
  color: white
  width: 35px
  height: 35px
  border-radius: 50%
  display: flex
  align-items: center
  justify-content: center
  cursor: pointer
  transition: background 0.3s ease

.modal-close-btn:hover
  background: rgba(255, 255, 255, 0.3)

.modal-body
  padding: 30px
  flex: 1
  overflow-y: auto

.modal-footer
  padding: 20px 30px
  background-color: #f8f9fa
  border-top: 1px solid #e9ecef
  text-align: center

/* Estados vazios */
.empty-state
  text-align: center
  padding: 40px 20px

/* Lista de publicações */
.publications-list
  display: flex
  flex-direction: column
  gap: 20px

.publication-item
  background: #f8f9fa
  border-radius: 12px
  padding: 20px
  border: 1px solid #e9ecef
  transition: transform 0.2s ease, box-shadow 0.2s ease

.publication-item:hover
  transform: translateY(-2px)
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1)

.publication-info
  margin-bottom: 15px

.publication-date
  color: #6c757d
  font-size: 0.85rem
  margin-bottom: 8px
  display: flex
  align-items: center

.publication-title
  font-weight: 600
  color: #2c3e50
  margin-bottom: 8px
  font-size: 1.1rem

.publication-description
  color: #6c757d
  font-size: 0.9rem
  margin-bottom: 0
  line-height: 1.5

.publication-actions
  text-align: right

/* Lista de vagas */
.vagas-list
  display: grid
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr))
  gap: 20px

.vaga-item
  background: #f8f9fa
  border-radius: 12px
  padding: 20px
  border: 1px solid #e9ecef
  transition: transform 0.2s ease, box-shadow 0.2s ease
  display: flex
  flex-direction: column
  height: 100%

.vaga-item:hover
  transform: translateY(-2px)
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1)

.vaga-header
  display: flex
  justify-content: space-between
  align-items: flex-start
  margin-bottom: 15px
  gap: 10px

.vaga-cargo
  font-weight: 600
  color: #2c3e50
  margin-bottom: 0
  font-size: 1rem
  line-height: 1.4
  flex: 1

.vaga-nivel
  font-size: 0.75rem
  padding: 6px 12px
  border-radius: 12px
  font-weight: 600
  color: white !important
  text-transform: uppercase
  letter-spacing: 0.5px
  white-space: nowrap
  flex-shrink: 0

.vaga-details
  flex: 1
  display: flex
  flex-direction: column
  justify-content: flex-end
  
  .vaga-info
    display: flex
    flex-direction: column
    gap: 10px

  .info-row
    display: flex
    align-items: center
    font-size: 0.9rem
    flex-wrap: wrap

  .info-label
    font-weight: 600
    color: #495057
    margin-right: 8px
    min-width: 100px
    font-size: 0.85rem

  .info-value
    color: #6c757d
    font-size: 0.95rem

  .info-value.price
    color: #28a745
    font-weight: 700
    font-size: 1.1rem
    letter-spacing: 0.3px

/* Responsividade dos modais */
@media (max-width: 768px)
  .modal-overlay
    padding: 10px
    padding-top: 30px

  .modal-content
    width: 100%
    max-height: calc(100vh - 40px)
    border-radius: 15px

  .modal-header
    padding: 20px

  .modal-body
    padding: 20px

  .modal-footer
    padding: 15px 20px

  .publication-item,
  .vaga-item
    padding: 15px

  .vaga-header
    flex-direction: column
    align-items: flex-start
    gap: 10px

  .info-row
    flex-direction: column
    align-items: flex-start
    gap: 5px

  .info-label
    min-width: auto

@media (max-width: 576px)
  .modal-overlay
    padding: 5px
    padding-top: 20px

  .modal-content
    max-height: calc(100vh - 25px)
    border-radius: 10px

  .modal-header
    padding: 15px

  .modal-body
    padding: 15px

  .modal-footer
    padding: 10px 15px

  .vagas-list
    grid-template-columns: 1fr
    gap: 15px

/* Responsividade */
@media (max-width: 768px)
  .hero-title
    font-size: 2rem

  .hero-subtitle
    font-size: 1rem

  .stat-card
    padding: 20px 10px

  .stat-number
    font-size: 1.5rem

  .filters-card
    padding: 20px

  .concurso-card-modern
    margin-bottom: 20px

  .card-footer-modern
    flex-direction: column

  .card-footer-modern .btn
    width: 100%
    margin-bottom: 5px

  .modal-content
    width: 95%
    padding: 20px

@media (max-width: 576px)
  .hero-section
    padding: 30px 0

  .hero-title
    font-size: 1.8rem

  .stat-card
    padding: 15px 10px

  .filters-card
    padding: 15px

  .card-body-modern
    padding: 15px

  .card-footer-modern
    padding: 10px 15px

/* Animações */
@keyframes fadeInUp
  from
    opacity: 0
    transform: translateY(30px)
  to
    opacity: 1
    transform: translateY(0)

.concurso-card-modern
  animation: fadeInUp 0.6s ease-out

/* Melhorias na tabela */
.table-hover tbody tr:hover
  background-color: rgba(0, 123, 255, 0.05)

.table th
  border-top: none
  font-weight: 600
  color: #495057
  background-color: #f8f9fa

/* Loading melhorado */
.is-loading
  width: 30px

/* Modal de Aviso */
.aviso-modal-overlay
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background: rgba(0, 0, 0, 0.6)
  display: flex
  justify-content: center
  align-items: center
  z-index: 1060
  backdrop-filter: blur(5px)
  animation: fadeIn 0.3s ease-out

.aviso-modal-content
  background: white
  border-radius: 20px
  width: 90%
  max-width: 500px
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3)
  animation: slideInUp 0.3s ease-out
  position: relative
  z-index: 1061
  overflow: hidden

.aviso-header
  background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%)
  color: white
  padding: 20px
  text-align: center
  position: relative

.aviso-icon
  font-size: 2.5rem
  margin-bottom: 10px
  opacity: 0.9

.aviso-title
  font-size: 1.3rem
  font-weight: 600
  margin-bottom: 0

.aviso-close-btn
  position: absolute
  top: 15px
  right: 15px
  background: rgba(255, 255, 255, 0.2)
  border: none
  color: white
  width: 35px
  height: 35px
  border-radius: 50%
  display: flex
  align-items: center
  justify-content: center
  cursor: pointer
  transition: background 0.3s ease

.aviso-close-btn:hover
  background: rgba(255, 255, 255, 0.3)

.aviso-body
  padding: 25px
  text-align: left

.aviso-text
  font-size: 0.95rem
  line-height: 1.6
  color: #495057
  margin-bottom: 15px
  text-align: justify

  &:last-of-type
    margin-bottom: 0

.aviso-footer
  padding: 15px 25px 25px
  text-align: center
  border-top: 2px solid #e9ecef

.btn-aviso-ok
  width: 100%
  padding: 11px
  border-radius: 10px
  font-weight: 600
  font-size: 0.95rem
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border: none
  transition: transform 0.3s ease, box-shadow 0.3s ease
  color: white

.btn-aviso-ok:hover
  transform: translateY(-2px)
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4)
  color: white

@keyframes fadeIn
  from
    opacity: 0
  to
    opacity: 1

@keyframes slideInUp
  from
    opacity: 0
    transform: translateY(-30px)
  to
    opacity: 1
    transform: translateY(0)
</style>
